import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

export default function Drawer({ open, onClose, title, children, wide }) {
  return (
    <Dialog.Root open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 animate-fade-in" />
        <Dialog.Content
          className={`fixed top-0 right-0 bottom-0 z-50 w-full ${wide ? 'max-w-2xl' : 'max-w-lg'} bg-white border-l border-gray-200 shadow-2xl overflow-y-auto animate-slide-in-right`}
          data-testid="drawer"
        >
          <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-5 border-b border-gray-200 bg-white/95 backdrop-blur-sm">
            <Dialog.Title className="text-lg font-bold text-gray-900">{title}</Dialog.Title>
            <Dialog.Close
              data-testid="drawer-close"
              className="p-2 rounded-xl hover:bg-gray-100 text-gray-400 hover:text-gray-700 transition-colors"
            >
              <X size={20} />
            </Dialog.Close>
          </div>
          <div className="p-6">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
